import GenericDB from './generic-db';

export default class VideoSessionsDB extends GenericDB {
  constructor() {
    super('videoSessions');
  }
}
